import { ThemeIcon } from '@src/theme/ThemeIcon';
import type { IconProps } from '@src/components/icons/IconProps';

export function GiftIcon({ className }: IconProps) {
  return (
    <ThemeIcon name="header-gift" className={className} fallback={
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9Z" />
      <path d="M3 7.5h18V11H3V7.5ZM12 7.5V21" />
      <path d="M12 7.5S10.8 3 8.6 3a2.3 2.3 0 0 0 0 4.5H12Zm0 0S13.2 3 15.4 3a2.3 2.3 0 0 1 0 4.5H12Z" />
    </svg>} />
  );
}
